import Affix from "./main.vue";

export default Affix;
